"use client";

import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Logout, Profile, Setting2, ArrowDown2 } from "iconsax-react";

import { Link } from "react-router-dom";

import { logout } from "@/actions/auth";
import { SupportedLanguage } from "@/lib/shared";
import lang from "../lang.json";
import { localizedPath } from "@/lib/localePath";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import getInitials from "@/lib/getInitials";

import { Button } from "@/components/ui/button";
import { TRole } from "@/actions/types";
import { useSignalRStatus } from "@/lib/signalR/useSignalR";
import { cn } from "@/lib/utils";

type ProfileMenuProps = {
  avatarSrc?: string;
  name?: string;
  locale: SupportedLanguage;
  role: TRole;
  session?: string;
  userId?: string;
  buttonRounded?: "full" | "md";
};

export default function ProfileMenu({
  avatarSrc = "/assets/avatar.jpg",
  name,
  locale,
  session,
  userId,
  role,
  buttonRounded = "full",
}: ProfileMenuProps) {
  const initials = name ? getInitials(name) : "U";

  const {
    // connectionState,
    isConnected,
    // error,
    // reconnectAttempts,
    // clearError,
    // reconnect,
  } = useSignalRStatus();

  // console.log({
  //   connectionState,
  //   isConnected,
  //   error,
  //   reconnectAttempts,
  //   clearError,
  //   reconnect,
  // });
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="xl"
          rounded={buttonRounded}
          className={cn(
            "!px-2 border",
            isConnected ? "border-green-500" : "border-red-500"
          )}
        >
          <Avatar className="">
            <AvatarImage src={avatarSrc} className="object-cover" />
            <AvatarFallback>{initials}</AvatarFallback>
          </Avatar>

          <ArrowDown2 className="fill-primary " size="24" variant="Outline" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[200px] p-2 rounded-xl"
        align={locale === "ar" ? "start" : "end"}
      >
        {/* <DropdownMenuLabel className="flex flex-col gap-y-1">
          <span className="font-medium">
            {lang["remaining-balance"][locale] || "Remaining Balance"}
          </span>
          <span className="text-sm text-muted-foreground">
            {translations(lang["n-posts"][locale], [String(remainingBalance)])}
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator /> */}
        <DropdownMenuItem asChild>
          <Link
            to={localizedPath(locale, "/me")}
            className="flex items-center gap-3 cursor-pointer text-primary"
          >
            <Profile
              size="24"
              variant="Outline"
              className="fill-current !text-inherit"
            />
            <span className="font-medium">
              {lang["my-profile"][locale] || "My Profile"}
            </span>
          </Link>
        </DropdownMenuItem>
        {/* 
        <DropdownMenuItem asChild>
          <Link
            href="/me/ads"
            className="flex items-center gap-3 cursor-pointer text-primary"
          >
            <Clipboard
              size="24"
              variant="Outline"
              className="fill-current !text-inherit"
            />
            <span className="font-medium">
              {lang["my-ads"][locale] || "My Ads"}
            </span>
          </Link>
        </DropdownMenuItem> */}

        <DropdownMenuItem asChild>
          <Link
            to={localizedPath(locale, "/settings")}
            className="flex items-center gap-3 cursor-pointer text-primary"
          >
            <Setting2
              size="24"
              variant="Outline"
              className="fill-current !text-inherit"
            />
            <span className="font-medium">
              {lang["setting"][locale] || "Setting"}
            </span>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <button
            onClick={async () => await logout()}
            className="flex w-full items-center gap-3 cursor-pointer text-red-500"
          >
            <Logout
              size="24"
              className="fill-current !text-inherit"
              variant="Outline"
            />
            <span className="font-medium">
              {lang["logout"][locale] || "Logout"}
            </span>
          </button>
        </DropdownMenuItem>

        {process.env.NODE_ENV === "development" && (
          <>
            <hr />
            <DropdownMenuItem asChild>
              <span className="">Role: {role}</span>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <button
                onClick={async () =>
                  navigator.clipboard.writeText(session || "")
                }
                className="flex items-center gap-3 cursor-pointer text-primary w-full"
              >
                <span className="font-medium">copy X-API-KEY</span>
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <button
                onClick={async () =>
                  navigator.clipboard.writeText(userId || "")
                }
                className="flex items-center gap-3 cursor-pointer text-primary w-full"
              >
                <span className="font-medium">copy User Id</span>
              </button>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
